var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-container",attrs:{"data-testid":"title"}},[_vm._v("Hi Administrator")])
}
var staticRenderFns = []

export { render, staticRenderFns }